import { render, staticRenderFns } from "./datosSobrantes.vue?vue&type=template&id=16af0072&scoped=true"
import script from "./datosSobrantes.vue?vue&type=script&lang=js"
export * from "./datosSobrantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16af0072",
  null
  
)

export default component.exports